import React from "react";
import AppBar from "@mui/material/AppBar";
import GlobalHeader from "../../../core/components/GlobalHeader/GlobalHeader";
import styles from "./styles";
import useAxios from "../../../core/hooks/useAxios";
import axios from "../../../utils/axiosUtil";
import Loader from "../Loader/Loader";
import { AppSnackbar } from "../AppSnackbar/AppSnackbar";
import { AppDialog } from "../AppDialog/AppDialog";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import { WarningPopup } from "@components/WarningPopup/WarningPopup";
import useStyles from "@hooks/useStyle";
import { MenuInterface } from "@mv-types";

const Layout = (props: { menu: MenuInterface[]; children: React.ReactNode }) => {
	const { children, menu } = props;
	const { classes } = useStyles(styles) as any;
	const [isLoading] = useAxios(axios) as any;
	return (
		<div className={classes.root}>
			{isLoading && <Loader />}
			<AppSnackbar />
			<AppDialog />
			<WarningPopup />
			<AppBar position="fixed" color="inherit" className={classes.appBar}>
				<GlobalHeader menu={menu} />
			</AppBar>
			<main className={classes.layoutMainContainer} id="layoutMainContainer">
				<ErrorBoundary>{children}</ErrorBoundary>
			</main>
		</div>
	);
};

export default React.memo(Layout);
